import { Component, ChangeDetectionStrategy } from '@angular/core';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { TutorialStep, tutorialStepsData } from './types/tutorial-step.types';
import { BehaviorSubject, take, map } from 'rxjs';

@Component({
    selector: 'c-upload-tutorial-modal',
    templateUrl: './upload-tutorial-modal.component.html',
    styleUrls: ['./upload-tutorial-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UploadTutorialModalComponent {
  readonly closeIcon = faXmark;
  //Inputs
  close: (submitted: boolean) => void;

  tutorialStepsData = tutorialStepsData;

  activeStep$ = new BehaviorSubject(TutorialStep.Corners);
  buttonText$ = this.activeStep$.pipe(
    map((step) =>
      this.findStepIndex(step) < this.tutorialStepsData.length - 1 ? 'common.next' : 'common.understand-go'
    )
  );

  next(): void {
    this.activeStep$.pipe(take(1)).subscribe((activeStep) => {
      const nextStep = this.findStepIndex(activeStep) + 1;
      if (nextStep < this.tutorialStepsData.length) {
        this.activeStep$.next(this.tutorialStepsData[nextStep].key);
      } else {
        this.close(true);
      }
    });
  }

  private findStepIndex(stepToFind: TutorialStep): number {
    return this.tutorialStepsData.findIndex((step) => step.key === stepToFind);
  }
}
